export const base64ListToFileList = async (base64OrList: string | string[]): Promise<File | File[] | null> => {
  if (!base64OrList) return null;

  const convertToFile = async (base64: string) => {
    // fetch automatically handles the Base64 string as a blob
    const response = await fetch(base64);
    const blob = await response.blob();
    return new File([blob], 'patient-intake', { type: blob.type });
  };

  if (Array.isArray(base64OrList)) {
    // Convert all Base64 strings to File objects
    return Promise.all(base64OrList.map(convertToFile));
  }
  return convertToFile(base64OrList);
};
